import React, { useState } from 'react';
import { KeywordBox } from '../../KeywordBox';
import { useTranslation } from 'react-i18next';
import './SemanticResultSection.css';
import GapGenerationModal from 'components/shared/modal/GapGenerationModal';

const SemanticResultSection = ({
  data,
  details,
  onUpdate,
  isReadOnly,
  combinedKeywords,
  handleKeywordChange,
  orderContentType,
  autoKeywordsGenerationLoading,
  isKeywordBoxReadOnly,
  keyword,
  url,
  orderWebsite,
  onLightGapError,
  contentScore,
  language,
  country,
  gapAnalysisEnabled = true,
  onGapEditingChange,
}) => {
  const { t } = useTranslation();
  const [isLightGapLoading] = useState(false);
  const [isAqisisGapLoading] = useState(false);
  const [isGapModalOpen, setIsGapModalOpen] = useState(false);
  const [gapMode, setGapMode] = useState('aqisis');
  return (
    <div className="semantic-result-content">
      {/* Section for Semantic Gap (Editable on click) */}
      <div className="semantic-section">
        <KeywordBox
          combinedKeywords={combinedKeywords}
          clientFreqV2={data?.clientFreqV2}
          handleKeywordChange={handleKeywordChange}
          orderContentType={orderContentType}
          autoKeywordsGenerationLoading={autoKeywordsGenerationLoading}
          isReadOnly={isKeywordBoxReadOnly}
          onEditingChange={onGapEditingChange}
          listHeight="360px"
        />


        <div className="semantic-gap-actions">
          <button
            type="button"
            className={`gap-light-btn ${!gapAnalysisEnabled ? 'gap-light-btn-disabled' : ''}`}
            onClick={() => {
              if (!gapAnalysisEnabled) return;
              setIsGapModalOpen(true);
            }}
            disabled={!gapAnalysisEnabled || isLightGapLoading || isAqisisGapLoading}
          >
            <span className="gap-refresh-icon">
              <img
                src="/Images/gap-icon-gene.png"
                alt={t('Générer une couverture sémantique')}
                style={{ width: 16, height: 16, marginLeft: -6 }}
              />
            </span>
            <span className="gap-refresh-label">
              {isLightGapLoading || isAqisisGapLoading
                ? t('Optimisation en cours...')
                : t('Générer une couverture sémantique')}
            </span>
          </button>
        </div>

        {/* <textarea
          className=" col-12  box-list-text"
          placeholder={
            'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)\n…'
          }
          value={gapText}
          onChange={isReadOnly ? undefined : (e) => setGapText(e.target.value)}
          readOnly={isReadOnly}
        ></textarea> */}
      </div>

      <div className="subsection-content">
        {details.recommendation && (
          <div className="ux-recommendation">
            <span className="recommendation-icon"></span>
            <div className="recommendation-content">
              <span className="recommendation-label">
                {t('Notre recommandation')} :{' '}
              </span>
              <span className="recommendation-text">
                {t(details.recommendation)}
              </span>
            </div>
          </div>
        )}

        {details.gratification && (
          <div className="success-message">
            <span className="emoji">🎉</span> {t(details.gratification)}
          </div>
        )}
      </div>

      <GapGenerationModal
        isOpen={isGapModalOpen}
        onClose={() => setIsGapModalOpen(false)}
        mode={gapMode}
        onModeChange={setGapMode}
        keyword={keyword}
        orderWebsite={orderWebsite}
        url={url}
        language={language}
        country={country}
        contentScore={contentScore}
        handleKeywordChange={handleKeywordChange}
        onUpdate={onUpdate}
        onLightGapError={onLightGapError}
        disableLightGap={!gapAnalysisEnabled}
      />
    </div>
  );
};

export default SemanticResultSection;
